export { default as Account } from '../../../views/Profile/AccountSection/Account.jsx';
export { EditProfile } from '../../../views/Profile/EditProfile.jsx';
export { default as Wishlist } from '../../../views/Profile/MyLists/Wishlist.jsx';
export { default as OrderDetails } from '../../../views/Profile/OrderSection/OrderDetails.jsx';
export { default as Orders } from '../../../views/Profile/OrderSection/Orders.jsx';
export { default as MyProfile } from '../../../views/Profile/ProfileSection/MyProfile.jsx';
export { default as EditUserProfile } from '../../../views/ProfileNew/EditProfile/EditProfile.jsx';
export { default as ViewProfileForm } from '../../../views/ProfileNew/EditProfile/Viewprofile.jsx';
export { default as UserProfile } from '../../../views/ProfileNew/index.jsx';
export { default as ViewOrders } from '../../../views/ProfileNew/Orders.jsx';

export { default as ForgotEmail } from '../../../views/loginOrRegister/ForgotEmail.jsx';
export { default as ForgotPassword } from '../../../views/loginOrRegister/ForgotPassword.jsx';
export { default as Login } from '../../../views/loginOrRegister/Login.jsx';
export { default as SetInstructorPassword } from '../../../views/loginOrRegister/SetInstructorPassword.jsx';
export { default as Signup } from '../../../views/loginOrRegister/Signup.jsx';
export { default as CommonActivationLink } from '../../../views/loginOrRegister/UserActivation.jsx';

export { default as AIComponent } from '../../../ai-component/index.jsx';
export { default as AiLogin } from '../../../ai-component/Login.jsx';

export { default as About } from '../../../views/about/index.jsx';
export { default as Career } from '../../../views/career/index.jsx';
export { default as Contact } from '../../../views/contact/index.jsx';

export { default as PolicyPage } from '../../../views/LegalDocuments/Policypage.jsx';
export { default as Cookies } from '../../../views/Policies/Cookies.jsx';
export { default as Disclaimer } from '../../../views/Policies/Disclaimer.jsx';
export { default as Policy } from '../../../views/Policies/Policy.jsx';
export { default as TermsConditions } from '../../../views/Policies/TermsConditions.jsx';
export { default as UserAcceptance } from '../../../views/Policies/UserAcceptance.jsx';

export { default as InvoicePayment } from '../../../views/invoice/index.jsx';
export { default as ViewInvoice } from '../../../views/invoice/ViewInvoice.jsx';
export { default as Cart } from '../../../views/payment/Cart.jsx';
export { default as FeePayment } from '../../../views/payment/FeePayment.jsx';
export { default as OrderHistory } from '../../../views/payment/OrderHistory.jsx';
export { default as OtpPayment } from '../../../views/payment/OtpPayment.jsx';
export { default as PaymentConfirmation } from '../../../views/payment/PaymentConfirmation.jsx';

export { default as ViewQuote } from '../../../views/quote/ViewQuote.jsx';
